import React from "react";
import { Button, Modal, Select, Input } from "antd";
import "./ModalEditUser.scss";
import useModalEditUser from "./logic/useModalEditUser";
import { Controller } from "react-hook-form";

const ModalEditUser = ({
  openEditModalUser,
  setOpenEditModalUser,
  userData,
}) => {
  const {
    handleSubmit,
    control,
    errors,
    listRoles,
    listDepartments, // Destructure listDepartments
    onUpdateUser,
    handleCancel,
  } = useModalEditUser(userData, openEditModalUser, setOpenEditModalUser);

  return (
    <Modal
      title={
        <h1
          style={{
            color: "#185993",
            fontWeight: "600",
            fontSize: "1.2rem",
          }}
        >
          EDIT USER ROLES
        </h1>
      }
      centered
      open={openEditModalUser}
      onCancel={handleCancel}
      width={800}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit(onUpdateUser)}
        >
          Save
        </Button>,
      ]}
    >
      <form onSubmit={handleSubmit(onUpdateUser)}>
        <div className="form-control-modal-user">
          <div className="first-row-modal-user">
            <div className="form-item">
              <label>First name</label>
              <div className="input-container">
                <Controller
                  name="firstName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "First Name is required" }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      placeholder="Enter a First Name"
                      readOnly
                    />
                  )}
                />
              </div>
              {errors.firstName && (
                <span className="error-msg">{errors.firstName?.message}</span>
              )}
            </div>
            <div className="form-item">
              <label>Last name</label>
              <div className="input-container">
                <Controller
                  name="lastName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Last Name is required" }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      placeholder="Enter a Last Name"
                      readOnly
                    />
                  )}
                />
              </div>
              {errors.lastName && (
                <span className="error-msg">{errors.lastName?.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-user">
            <div className="form-item">
              <label>Email</label>
              <div className="input-container">
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Email is required" }}
                  render={({ field }) => (
                    <Input {...field} placeholder="Enter an Email" readOnly />
                  )}
                />
              </div>
              {errors.email && (
                <span className="error-msg">{errors.email?.message}</span>
              )}
            </div>
            <div className="form-item">
              <label>Title</label>
              <div className="input-container">
                <Controller
                  name="title"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Title is required" }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      placeholder="Enter a Title"
                      readOnly={
                        userData.title !== "" && userData.title !== null
                      }
                    />
                  )}
                />
              </div>
              {errors.title && (
                <span className="error-msg">{errors.title?.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-user">
            <div className="form-item">
              <label>Phone</label>
              <div className="input-container">
                <Controller
                  name="telephone"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Phone number is required",
                    pattern: {
                      value: /^(?:\+\d{1,3}|00\d{1,3})?\d{8}$/,
                      message:
                        "Phone number must be in the format 12345678, +xxx12345678, or 00xxx12345678 and should not exceed 11 digits.",
                    },
                    validate: (value) => {
                      if (
                        value &&
                        /^(?:\+\d{1,3}|00\d{1,3})\d{7}$/.test(value)
                      ) {
                        return "Invalid phone number format, must be in the format +xxx12345678 or 00xxx12345678.";
                      }
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      placeholder="Enter a Phone number"
                    />
                  )}
                />
              </div>
              {errors.telephone && (
                <span className="error-msg">{errors.telephone?.message}</span>
              )}
            </div>

            <div className="form-item">
              <label>Roles</label>
              <div className="input-container">
                <Controller
                  name="roles"
                  control={control}
                  rules={{ required: "Roles is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      mode="multiple"
                      placeholder="Select roles"
                      options={listRoles}
                    />
                  )}
                />
              </div>
              {errors.roles && (
                <span className="error-msg">{errors.roles?.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-user">
            <div className="form-item">
              <label>Department</label>
              <div className="input-container-department">
                <Controller
                  name="department"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder="Select department"
                      options={listDepartments} // Add department options
                    />
                  )}
                />
              </div>
              {errors.department && (
                <span className="error-msg">{errors.department?.message}</span>
              )}
          </div>
            </div>
        </div>
      </form>
    </Modal>
  );
};

export default ModalEditUser;
